import { render, staticRenderFns } from "./CvSendConfirm.vue?vue&type=template&id=633d8770&scoped=true"
import script from "./CvSendConfirm.vue?vue&type=script&lang=js"
export * from "./CvSendConfirm.vue?vue&type=script&lang=js"
import style0 from "./CvSendConfirm.vue?vue&type=style&index=0&id=633d8770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d8770",
  null
  
)

export default component.exports